module.exports = __webpack_public_path__ + "img/cellphone.07845970.svg";